import { render, staticRenderFns } from "./OrganizationDetails.vue?vue&type=template&id=3f69741b&scoped=true"
import script from "./OrganizationDetails.vue?vue&type=script&lang=js"
export * from "./OrganizationDetails.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDetails.vue?vue&type=style&index=0&id=3f69741b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f69741b",
  null
  
)

export default component.exports